//External
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
//Internal
import {
  get_cookie,
} from "../../utils";
import { getUserInfo } from "../../store/actions/user";
import falconWhiteImage from "../../public/assets/images/Falco_logo_icon_white.png";
// import { CDN_PATH } from "config";

/*******************
  @Purpose : used for reservation header
  @Parameter : {brandList,currentLocationId,categoryList,currentPage,callUserInfo,headerDark,locations,selectedLocationName,...rest}
  @Author : INIC
  *******************/
function ReservationHeader({
  step,
  currentPage,
  callUserInfo,
  headerDark,
  useBlackLogo = false,
  onBack,
}) {
  const user = useSelector((state) => state?.user);
  const router = useRouter();
  const dispatch = useDispatch();
  const [showHeader, setShowHeader] = useState(false);
  const reservationData = useSelector((state) => state?.booking?.reservation);
  /*******************
  @Purpose : used for scroll page
  @Parameter : {}
  @Author : INIC
  *******************/
  const didScrollPage = (e) => {
    const headerStickyOffset = 50;
    if (window.scrollY > headerStickyOffset) {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  };

  /*******************
  @Purpose : used for home click redirect
  @Parameter : {}
  @Author : INIC
  *******************/
  const homeClickRedirect = () => {
    const r = get_cookie("redirectUrl");
    if (r) {
      router.push(r);
    } else {
      router.push("/");
    }
  };

  /*******************
  @Purpose : used for edit click redirect
  @Parameter : {}
  @Author : INIC
  *******************/
  const handleClick = () => {
    if (onBack) {
      onBack();
      return;
    }
    router.push(`/vehiclebooking/${reservationData.id}`);
  };

  /*******************
  @Purpose : React Hook dispatch user info
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    if (user?.token) {
      // Check if user is a guest (new user)
      const isGuest = get_cookie("is_guest") === "true";

      // Only call profile API for existing users (not guests)
      if (!isGuest) {
        dispatch(getUserInfo());
      }
    }
  }, [callUserInfo]);

  /*******************
  @Purpose : React Hook used for add and remove event listener
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    // If useBlackLogo is true, always show sticky header and don't listen to scroll
    if (useBlackLogo) {
      setShowHeader(true);
      return;
    }
    // Otherwise, listen to scroll for sticky behavior
    window.addEventListener("scroll", didScrollPage, 10);
    return () => {
      window.removeEventListener("scroll", didScrollPage);
    };
  }, [useBlackLogo]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <header
      className={`header ${showHeader ? "sticky" : ""} ${headerDark ? "header-dark" : ""
        } ${currentPage == "404" ? "bg-black box-shadow-none border-0" : ""}`}
    >
      <div className="custom-container">
        <Navbar className="justify-content-center">
          <div onClick={homeClickRedirect} className="header-logo">
            <Navbar.Brand className="p-0">
              <img
                // src={CDN_PATH + "/logo.png"}
                src={falconWhiteImage}
                title="Falcon car rental"
                width={"119px"}
                alt="Falcon car rental"
              />
            </Navbar.Brand>
          </div>
        </Navbar>
        {step && (step === "1" || step === "2") && (
          <div className="back-chevron-btn">
            <span
              className="icon icon-left-chevron"
              onClick={handleClick}
            ></span>
          </div>
        )}
      </div>
    </header>
  );
}

export default ReservationHeader;
